var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "destinations" }, [
    _c("span", [
      _vm._v(" " + _vm._s(_vm.$t("editor.FIELD_DESTINATION")) + ": "),
    ]),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.dest,
            expression: "dest",
          },
        ],
        on: {
          change: [
            function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.dest = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
            function ($event) {
              return _vm.onChange($event)
            },
          ],
        },
      },
      _vm._l(_vm.destOptions, function (option) {
        return _c(
          "option",
          { key: option.value, domProps: { value: option.value } },
          [_vm._v("\n      " + _vm._s(option.text) + "\n    ")]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }